$( document ).ready(function() {
    $('#apply_filters').on('click', applyFilters);
    $('#clear_filters').on('click', clearFilters);

    $('.filter-checkbox').on('click', function (){
        var filter_enabled = $('#filter_enabled').val();
        if(filter_enabled == 1) {
            filterProducts();
        }
    });

});

function applyFilters() {
    initFilteredContent();
    $('#apply_filters').hide();
    $('#clear_filters').show();
    $('#filter_enabled').val(1);
    filterProducts();
    var check_if_mobile = detectIfMobile();
    if(check_if_mobile == true){
        $('.close-filter').click();
    }
}

function clearFilters() {
    disableFilteredContent();
    $('#apply_filters').show();
    $('#clear_filters').hide();
    $('#filter_enabled').val(0);
    $('#filter_results').empty();
}

function detectIfMobile() {
    const toMatch = [
        /Android/i,
        /webOS/i,
        /iPhone/i,
        /iPad/i,
        /iPod/i,
        /BlackBerry/i,
        /Windows Phone/i
    ];

    return toMatch.some((toMatchItem) => {
        return navigator.userAgent.match(toMatchItem);
    });
}


function filterProducts() {

    const filtersList = new Object();
    const values = new Object();
    const filterValuesForBlock = new Object();

    var i = 0;
    var key_filter_block = '';
    var active_filters = 0;
    $('.filter-checkbox').each(function(){
        if($(this).is(':checked')){
            var filter_value = $(this).val();
            var filter_type = $(this).data('filter-type');

            if(!filtersList[filter_type]) {
                filtersList[filter_type] = {};
            }

            filtersList[filter_type][i] = {
                'value': filter_value
            }
            active_filters++;
            i++;
        }
    });

    if(active_filters > 0){
        $('.CDE_filter_product_grid').hide().attr('data-hide-product',0);

        $('#filter_results').text('Loading...');

        var j=1;

        Object.keys(filtersList).forEach(key => {
            var filterListElement = filtersList[key];

            $('.CDE_filter_product_grid').each(function () {
                var show_product = 0;
                var product_filter = $(this).data('product-' + key + '-filters');
                var hide_status = $(this).attr('data-hide-product');

                if(product_filter!='' && hide_status != '1' && hide_status != 1) {
                    Object.keys(filterListElement).forEach(key1 => {
                        if(product_filter.toLowerCase()==filterListElement[key1].value.toLowerCase()){
                            show_product = 1
                        }
                    });
                    if(show_product == 1){

                    }else{
                        $(this).attr('data-hide-product', 1);
                    }
                }else{
                    $(this).attr('data-hide-product', 1);
                }
            });

            j++;
        });
        setTimeout(function() {
            $('#filter_results').empty();
            var uniq_products = [];
            var i = 0;
            $('.CDE_filter_product_grid').each(function () {

                var hide_status = $(this).attr('data-hide-product');
                var product_id = $(this).data('product-id');
                var can_add_this_product = 1;

                $('.CDE_filter_product_grid').hide();

                if(uniq_products.includes(product_id)){
                    can_add_this_product = 0;
                }else{
                    uniq_products[i] = product_id;
                }

                if (hide_status != '1' && hide_status != 1 && can_add_this_product == 1) {
                    var product_grid_element = $(this).html();
                    $('#filter_results').append('<div class="grid-column column-33">' + product_grid_element + '</div>');
                }
                i++;
            });
            reloadProductSliders();
        }, 500);

    }else{
        clearFilters();
    }
}

function disableFilteredContent(){
    $('.filter-hide-content').show();
    $('.CDE_filter_product_grid').show().attr('data-hide-product',0);
}

function initFilteredContent(){
    $('.filter-hide-content').hide();
}

function initStartProductFilter() {
    $('.CDE_filter_product_grid').each(function(){
        var i = 1;
        while (filter_blocks_count >= i) {
            $(this).attr('data-filter-block-' + i, 0);
            i++;
        }
    });
}

function reloadProductSliders(){
    jQuery('#filter_results .product-item-wrap').each(function () {
        var productItem = jQuery(this);
        jQuery('.product-image-slider', productItem).removeAttr('class');
        jQuery('.product-image-slider', productItem).addClass('.product-image-slider owl-carousel')
        var previewProductSlider = jQuery('.product-image-slider', productItem);
        previewProductSlider.owlCarousel({
            items: 1,
            nav: false,
            navText: ['<span class="slide-arrow prev-slide"></span>', '<span class="slide-arrow next-slide"></span>'],
            dots: false,
            loop: false,
        });
    });
}
